<template>
  <div>
    <el-dialog :title="customerServiceData.title" :visible.sync="customerServiceData.show" width="1200px" center>
      <el-form inline :model="editForm" label-width="100px">
        <el-form-item>
          <h4>{{ $t('OnlineCustomerServiceLink') }}</h4>
          <el-row>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">{{$t('Chinese')}}：</span><el-input clearable style="width: 200px" v-model="editForm.CustomeService" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">英文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomeServiceen" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">泰文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomeServicetd" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">韩文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomeServiceko" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">土耳其文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomeServicetr" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">越南文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomeServicevi" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">葡萄牙文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomeServicept" :placeholder="$t('EnterOnlineCustomerServiceLink')"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <h4>skyp{{ $t('CustomerServiceLink') }}</h4>
          <el-row>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">{{$t('Chinese')}}：</span><el-input clearable style="width: 200px" v-model="editForm.CustomSkype" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">英文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomSkypeen" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">泰文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomSkypetd" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">韩文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomSkypeko" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">土耳其文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomSkypetr" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">越南文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomSkypevi" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">葡萄牙文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomSkypept" :placeholder="$t('EnterSkypeCustomerServiceLink')"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <h4>TG{{ $t('CustomerServiceLink') }}</h4>
          <el-row>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">{{$t('Chinese')}}：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegram" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">英文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegramen" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">泰文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegramtd" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">韩文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomTelegramko" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">土耳其文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomTelegramtr" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">越南文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomTelegramvi" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">葡萄牙文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegrampt" :placeholder="$t('EnterTGCustomerServiceLink')"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <h4>{{$t('OfficialChannelLink')}}</h4>
          <el-row>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">{{$t('Chinese')}}：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGroup" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">英文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGroupen" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">泰文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGrouptd" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">韩文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGroupko" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">土耳其文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGrouptr" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">越南文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGroupvi" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">葡萄牙文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomTelegramGrouppt" :placeholder="$t('EnterOfficialChannelLink')"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <h4>whatApp{{ $t('CustomerServiceLink') }}</h4>
          <el-row>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">{{$t('Chinese')}}：</span><el-input clearable style="width: 200px" v-model="editForm.CustomWhatapp" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">英文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomWhatappen" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">泰文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomWhatapptd" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">韩文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomWhatappko" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">土耳其文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomWhatapptr" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">越南文：</span> <el-input clearable style="width: 200px" v-model="editForm.CustomWhatappvi" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
            <el-col :span="6">
              <span style="display: inline-block;width:70px; text-align: right;">葡萄牙文：</span><el-input clearable style="width: 200px" v-model="editForm.CustomWhatapppt" :placeholder="$t('EnterWhatAppCustomerServiceLink')"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="customerServiceData.show = false">{{$t('Cancel')}}</el-button>
        <el-button size="medium" type="primary" @click="submitEditRow">{{ $t('Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  props: {
    customerServiceData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editForm: {
        CustomeService: "",
        CustomeServiceen: "",
        CustomeServicetd: "",
        CustomeServiceko: "",
        CustomeServicetr: "",
        CustomeServicevi: "",
        CustomeServicept: "",
        CustomSkype: "",
        CustomSkypeen: "",
        CustomSkypetd: "",
        CustomSkypeko: "",
        CustomSkypetr: "",
        CustomSkypevi: "",
        CustomSkypept: "",
        CustomTelegram: "",
        CustomTelegramen: "",
        CustomTelegramtd: "",
        CustomTelegramko: "",
        CustomTelegramtr: "",
        CustomTelegramvi: "",
        CustomTelegrampt: "",
        CustomTelegramGroup: "",
        CustomTelegramGroupen: "",
        CustomTelegramGrouptd: "",
        CustomTelegramGroupko: "",
        CustomTelegramGrouptr: "",
        CustomTelegramGroupvi: "",
        CustomTelegramGrouppt: "",
        CustomWhatapp: "",
        CustomWhatappen: "",
        CustomWhatapptd: "",
        CustomWhatappko: "",
        CustomWhatapptr: "",
        CustomWhatappvi: "",
        CustomWhatapppt: "",
      },
    };
  },
  created() {
    if (this.customerServiceData.rowData.CustomeService) {
      let obj = JSON.parse(this.customerServiceData.rowData.CustomeService);
      this.editForm = { ...obj };
    }
  },
  methods: {
    submitEditRow() {
      let obj = {};
      for (const key in this.editForm) {
        if (this.editForm[key]) {
          obj[key] = this.editForm[key];
        }
      }
      this.customerServiceData.rowData.CustomeService = JSON.stringify(
        this.editForm
      );
      this.$emit("submitCustomerServiceData", this.customerServiceData.rowData);
    },
  },
};
</script>

<style scoped>
::v-deep .el-form-item {
  margin-bottom: 0;
}
.el-col-6 {
  padding-bottom: 5px;
}
</style>
